import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { Typography, SvgIcon, Link, TextField } from '@material-ui/core';

import AdornedButton from '../../../commons/AdornedButton';
import RTVDialog from '../../../commons/dialogs/RTVDialog';
import { updateUser } from '../../../redux/actions/auth';
import {
  UPDATE_USER_REQUESTED,
  UPDATE_USER_SUCCESSFULL,
  UPDATE_USER_ERRORED
} from '../../../redux/actions/types';
import { ReactComponent as EditIcon } from '../../../images/Icons/edit.svg';
import removeEmoji from '../../../utils/removeEmoji';
import i18next from 'i18next';

const styles = theme => ({
  root: {
    display: 'flex',
    flexFlow: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing(2),
    '& > *': {
      textAlign: 'center'
    }
  },
  header: {
    fontWeight: 600
  },
  descriptionText: {
    fontWeight: 500,
    color: theme.palette.primary.main,
    fontStyle: 'italic'
  },
  editButton: {
    cursor: 'pointer',
    textDecoration: 'underline',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    fontSize: '0.9rem'
  },
  editButtonSection: {
    width: '100%',
    maxWidth: '600px'
  },
  input: {
    border: 'none',
    boxShadow: '0 0.5px 10px 0 rgba(0, 0, 0, 0.2)',
    '& > fieldset': {
      border: 'none',
      '&:hover': {
        border: 'none'
      },
      '&:active': {
        border: 'none'
      }
    },
    '&:hover': {
      border: 'none'
    }
  },
  descriptionSection: {
    width: '100%',
    maxWidth: '600px',
    padding: theme.spacing(2)
  }
});

class Description extends Component {
  constructor(props) {
    super();

    const startEditing = !props.description && props.editable;

    this.state = {
      fullView: !!props.editable,
      editing: startEditing,
      initialDescription: props.description || '',
      description: props.description || '',
      changes: false,
      loading: false,
      error: {
        open: false,
        content: {}
      }
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.status !== this.props.status) {
      if (
        this.props.status === UPDATE_USER_REQUESTED &&
        this.props.userChanges.includes('description')
      ) {
        this.setState({
          loading: true
        });
      }
      if (
        this.props.status === UPDATE_USER_SUCCESSFULL &&
        this.props.userChanges.includes('description')
      ) {
        this.setState(state => ({
          loading: false,
          editing: false,
          changes: false,
          initialDescription: state.description
        }));
      }
      if (
        this.props.status === UPDATE_USER_ERRORED &&
        this.props.userChanges.includes('description')
      ) {
        if (this.props.error && this.props.error.status === 409) {
          this.setState({
            error: {
              open: true,
              content: {
                title: 'Uuups!',
                message:
                  'Parece que hubo un error al actualizar tu descripcion. Asegurate de no compartir datos personales y/o de contacto.'
              }
            },
            loading: false
          });
          return;
        }
        this.setState({
          loading: false
        });
      }
    }
  }

  toggleView = () => {
    this.setState(state => ({
      ...state,
      fullView: !state.fullView
    }));
  };

  setEditing = () => {
    this.setState({ editing: true });
  };

  handleChange = ({ target: { value } }) => {
    this.setState(state => ({
      description: removeEmoji(value.substring(0, 500)),
      changes: value !== state.initialDescription
    }));
  };

  save = () => {
    this.props.updateUser(this.state.description);
  };

  render() {
    const { classes } = this.props;
    const { description } = this.state;

    return (
      <div className={classes.root}>
        <Typography variant="h5" className={classes.header}>
          SOBRE MÍ
        </Typography>

        <RTVDialog
          open={this.state.error.open}
          onClose={() => this.setState({ error: { open: false, content: {} } })}
          {...this.state.error.content}
        />

        <div className={classes.descriptionSection}>
          {!this.state.editing && (
            <Typography className={classes.descriptionText}>
              {this.state.fullView ||
              description.length <= 144 ||
              this.props.editable ? (
                <Typography
                  style={{
                    textAlign: `${description.length <= 144 ? '' : 'justify'}`
                  }}
                >
                  {description}
                </Typography>
              ) : (
                `${description.slice(0, 144)}...`
              )}
            </Typography>
          )}
          {this.state.editing && (
            <TextField
              fullWidth
              InputProps={{ className: classes.input }}
              placeholder={i18next.t('aboutMyself', { ns: 'dresser' })}
              type="text"
              multiline
              rows={5}
              disabled={this.state.loading}
              value={this.state.description}
              onChange={this.handleChange}
              variant="outlined"
              helperText={`No incluyas datos personales o links. ${description.length}/500`}
            />
          )}
        </div>
        <div className={classes.editButtonSection}>
          {this.props.editable && !this.state.editing && (
            <Typography
              onClick={this.setEditing}
              component="span"
              className={classes.editButton}
            >
              <SvgIcon style={{ marginRight: '4px' }}>
                <EditIcon />
              </SvgIcon>
              Editar description
            </Typography>
          )}
          {description.length > 144 &&
            !this.state.fullView &&
            !this.props.editable && (
              <Link style={{ textAlign: 'right' }} onClick={this.toggleView}>
                Ver más
              </Link>
            )}
          {this.state.changes && (
            <AdornedButton
              variant="contained"
              color="primary"
              loading={this.state.loading}
              disabled={this.state.loading}
              className={classes.saveButton}
              onClick={this.save}
            >
              Guardar
            </AdornedButton>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  status: state.auth.status,
  userChanges: state.auth.userChanges,
  error: state.auth.error
});

const mapDispatchToProps = dispatch => ({
  updateUser: description => dispatch(updateUser({ description }))
});

export default withStyles(styles)(
  connect(mapStateToProps, mapDispatchToProps)(Description)
);
